"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroStream = void 0;
class AllegroStream {
    view;
    pos;
    length;
    constructor(buffer) {
        this.view = new DataView(buffer);
        this.pos = 0;
        this.length = buffer.byteLength;
    }
    position() {
        return this.pos;
    }
    size() {
        return this.length;
    }
    hasMore() {
        return this.pos < this.length;
    }
    seek(offset) {
        if (offset < 0 || offset > this.length) {
            throw new Error(`Seek out of bounds: ${offset} (file size: ${this.length})`);
        }
        this.pos = offset;
    }
    skip(bytes) {
        if (this.pos + bytes > this.length) {
            throw new Error(`Skip past end of stream at offset 0x${this.pos.toString(16)} (skip ${bytes} bytes, file size: ${this.length})`);
        }
        this.pos += bytes;
    }
    skipU32(count) {
        const byteCount = count * 4;
        if (this.pos + byteCount > this.length) {
            throw new Error(`Skip past end of stream at offset 0x${this.pos.toString(16)} (skip ${byteCount} bytes, file size: ${this.length})`);
        }
        this.pos += byteCount;
    }
    readU8() {
        if (this.pos >= this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const val = this.view.getUint8(this.pos);
        this.pos += 1;
        return val;
    }
    tryReadU8() {
        if (this.pos >= this.length) {
            return undefined;
        }
        const val = this.view.getUint8(this.pos);
        this.pos += 1;
        return val;
    }
    readU16() {
        if (this.pos + 2 > this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const val = this.view.getUint16(this.pos, true);
        this.pos += 2;
        return val;
    }
    readS16() {
        if (this.pos + 2 > this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const val = this.view.getInt16(this.pos, true);
        this.pos += 2;
        return val;
    }
    readU32() {
        if (this.pos + 4 > this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const val = this.view.getUint32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readS32() {
        if (this.pos + 4 > this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const val = this.view.getInt32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readFloat64Swapped() {
        const hi = this.readU32();
        const lo = this.readU32();
        const buf = new ArrayBuffer(8);
        const dv = new DataView(buf);
        dv.setUint32(0, hi, false);
        dv.setUint32(4, lo, false);
        return dv.getFloat64(0, false);
    }
    readAllegroFloat() {
        return this.readFloat64Swapped();
    }
    readBytes(count) {
        if (this.pos + count > this.length) {
            throw new Error(`Read past end of stream at offset 0x${this.pos.toString(16)}`);
        }
        const result = new Uint8Array(this.view.buffer, this.pos, count);
        this.pos += count;
        return new Uint8Array(result);
    }
    readString(roundToNextU32) {
        const start = this.pos;
        while (this.pos < this.length && this.view.getUint8(this.pos) !== 0) {
            this.pos++;
        }
        const bytes = new Uint8Array(this.view.buffer, start, this.pos - start);
        if (this.pos < this.length) {
            this.pos++;
        }
        if (roundToNextU32 && this.pos % 4 !== 0) {
            const padding = 4 - (this.pos % 4);
            this.skip(padding);
        }
        return new TextDecoder("ascii").decode(bytes);
    }
    readStringFixed(length, roundToNextU32) {
        const bytes = this.readBytes(length);
        if (roundToNextU32 && this.pos % 4 !== 0) {
            const padding = 4 - (this.pos % 4);
            this.skip(padding);
        }
        const nullIdx = bytes.indexOf(0);
        const validBytes = nullIdx >= 0 ? bytes.subarray(0, nullIdx) : bytes;
        return new TextDecoder("ascii").decode(validBytes);
    }
    readArrayU32(count) {
        const result = [];
        for (let i = 0; i < count; i++) {
            result.push(this.readU32());
        }
        return result;
    }
    readArrayS32(count) {
        const result = [];
        for (let i = 0; i < count; i++) {
            result.push(this.readS32());
        }
        return result;
    }
    readArrayU16(count) {
        const result = [];
        for (let i = 0; i < count; i++) {
            result.push(this.readU16());
        }
        return result;
    }
    readArrayU8(count) {
        const result = [];
        for (let i = 0; i < count; i++) {
            result.push(this.readU8());
        }
        return result;
    }
}
exports.AllegroStream = AllegroStream;
//# sourceMappingURL=stream.js.map